// extracted by mini-css-extract-plugin
export default {"product-info-section":"xh6UgF1UgvH85BUFBolD","section-title":"GT9cauOmMIXBWWc_Je2V","divider-wrapper":"BOC73r6qSmJtwnzI2CqQ"};